<template>
  <v-app>
    <v-content style="min-height: 1px">
      <router-view />
    </v-content>
    <modal-timer />
  </v-app>
</template>

<script>
import store from './vuex/store.js'
import axios from 'axios'

import { useWindowResize } from '@sichern/ui-elements'
import ModalTimer from '@/components/generics/modalTimer.vue'

export default {
  name: 'App',
  components: { ModalTimer },
  created() {

    const jwt = this.$store.getters.getJwt
    const jwt2 = localStorage.getItem('jwt')
    if (jwt && jwt2) {
      this.$iframeMessages.setAuthenticated(true)
    }

    // Agregar clase iframe-mode al body si estamos en iframe con token válido
    if (this.$iframeMessages && this.$iframeMessages.isTokenValid()) {
      document.body.classList.add('iframe-mode')
    }

    if (performance.navigation.type == 1) {
      localStorage.setItem('pageReload', 1)
    } else {
      localStorage.setItem('pageReload', 0)
    }

    window.scrollTo(0, 0)
    const that = this

    let asd = () => {
      axios.interceptors.response.use(
        function(response) {
          return response
        },
        function(error) {
          if (!error.response) {
            return Promise.reject(error)
          }
          if (error.response.status === 400) {
            //Esto pasa al flushear redis
            if (error.response.data.hasOwnProperty('response_v2')) {
              if (error.response.data.response_v2.code === '00003') {
                store.dispatch('clearState')
                that.redirectToLogin()
                return Promise.reject(error)
              }
            }
          }
          const isLoginRequest = error.config && error.config.url && error.config.url.includes('auth-mod/login');
          const isUserLinkTokenExpired = error.response && 
                                         error.response.data && 
                                         error.response.data.codes && 
                                         error.response.data.codes[0] && 
                                         error.response.data.codes[0].code === 'USER_LINK_TOKEN_EXPIRED';

          if (
            error.response.status === 401 &&
            error.config &&
            !isLoginRequest &&
            !error.config.__isRetryRequest &&
            !that.$route.params.hasOwnProperty('ssoToken') &&
            !isUserLinkTokenExpired
          ) {
            //Esto pasa cuando se vence la sesion
            that.redirectToLogin()
            return Promise.reject(error)
          }

          if (error.response.status === 500) {
            const errorCode = error.response.data && error.response.data.response_v2 
              ? error.response.data.response_v2.code 
              : 'UNKNOWN_ERROR';
            that.$swal({
              type: 'error',
              title: that.$t(`message.errorReference.${errorCode}`),
              showConfirmButton: true,
              confirmButtonText: that.$t('message.settingsComponent.list.okMsg')
            })
          } else {
            throw error
          }
        }
      )
    }
    asd()

  },
  data() {
    return {
      headerView: 1,
      windowResize: useWindowResize(this)
    }
  },
  methods: {
    redirectToLogin() {
      localStorage.removeItem('jwt')
      this.$store.dispatch('clearState')
      this.$router.push({ name: 'login' })
    },
  }
}
</script>

<style lang="scss">
@import './public/assets/scss/_config.scss';

html {
  font-size: 14px !important;
  font-family: Roboto, Arial, sans-serif;
}

.zt-button-disabled[data-v-4d60d355] {
  background-color: $background !important;
  color: $grayFont !important;
  font-family: Roboto, Arial, sans-serif;
  font-size: $font-small !important;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12) !important;
  line-height: normal;
}

.grecaptcha-badge {
  visibility: hidden;
}

.v-btn {
  min-width: 0;
}

.icon-LogOut:before {
  color: white;
}

.icon-Filters:before {
  color: white;
}

.icon-Close:before {
  color: white;
}

.icon-Download:before {
  color: white;
}

.icon-LeftChevron:before {
  font-size: 1.5em;
}

.icon-RightChevron:before {
  font-size: 1.5em;
}

.icon-Ok:before {
  color: $buttonPrimary;
  margin: auto 0;
  font-size: 1em;
}

.icon-NotOk:before {
  color: $error;
  margin: auto 0;
  font-size: 1em;
}

.icon-History:before {
  color: $pendingEllipse;
  margin: auto 0;
  font-size: 1em;
}

.btn {
  width: 126px;
  height: 36px;
}

.btn[disabled] {
  background: #bcbcbc;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: $white;

  &:hover {
    background: #bcbcbc;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    font-family: Roboto, Arial, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: $white;
  }
}

.v-text-field--outline > .v-input__control > .v-input__slot {
  border-color: #969696 !important;
  color: #969696 !important;
}

.v-text-field--outline > .v-input__control > .v-input__slot :after {
  border-color: $primary-color-200 !important;
}

.v-input__slot {
  color: $primary-color-200;
}

.v-input__slot:after {
  border-color: $primary-color-200 !important;
}

.v-input__slot::before {
  border-bottom: 0.3px solid #969696 !important;
  opacity: 0.2;
  color: $text-secondary !important;
}

.v-input__slot[disabled] {
  color: red !important;
  width: 150% !important;
}

.v-text-field__slot {
  input[disabled] {
    color: $textPrimary !important;
  }

  textarea[disabled] {
    color: $textPrimary !important;
  }
}

.v-label.v-label--active.v-label--is-disabled.theme--light {
  color: $textSecondary !important;
}

.v-icon--disabled {
  color: $textPrimary !important;
}

.v-icon.v-icon--disabled.material-icons.theme--light {
  color: $textPrimary !important;
}

.buttonPrimaryProperties {
  color: var(--branding-textColor, white);
  background-color: var(--branding-lightThemeBg, var(--branding-primary, var(--v-primary-base)));
  border-color: var(--branding-lightThemeBg, var(--branding-primary, var(--v-primary-base)));
  font-size: 14px;
  font-weight: 500;
  height: 36px;
  padding-top: 0px;
  padding-bottom: 0px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  margin-left: 2.2em !important;

  &:hover {
    background-color: var(--branding-secondary, $bluePrimary);
    border-color: var(--branding-secondary, $bluePrimary);
    outline-color: var(--branding-secondary, $bluePrimary) !important;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  }

  &:focus {
    outline-color: $buttonPrimaryOver !important;
    color: $white;
  }
}

.buttonSecondaryProperties {
  background-color: $white !important;
  border-radius: 2px;
  border: 1px solid var(--branding-lightThemeBg, var(--branding-primary, var(--v-primary-base)));;
  color: var(--branding-lightThemeBg, var(--branding-textColor, var(--v-primary-base)));
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;

  &:hover {
    color: $white !important;
    background-color: var(--branding-secondary, $bluePrimary) !important;
    border-color: var(--branding-secondary, $bluePrimary);

    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  }

  &:focus {
    outline-color: $bluePrimary !important;
    color: $white;
  }
}

.text-zt-secondary-200 {
  color: var(--branding-titleColor, var(--v-buttonSecondary-base)) !important;
  caret-color: var(--branding-titleColor, var(--v-buttonSecondary-base)) !important;
}

.buttonSwallCancelProperties {
  background-color: $white !important;
  border-radius: 2px;
  border: 1px solid #2470a0;
  color: $bluePrimary;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;

  &:hover {
    color: $white !important;
    background-color: $bluePrimary !important;
    border-color: $bluePrimary;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  }

  &:focus {
    outline-color: $bluePrimary !important;
    color: $white !important;
  }
}

.buttonSwallConfirmProperties {
  color: white;
  background-color: $buttonPrimary;
  border-color: $buttonPrimary;
  font-size: 14px;
  font-weight: 500;
  height: 36px;
  padding-top: 0px;
  padding-bottom: 0px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  margin-left: 2.2em !important;

  &:hover {
    background-color: $buttonPrimaryOver;
    border-color: $buttonPrimaryOver;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  }

  &:focus {
    outline-color: $buttonPrimaryOver !important;
    color: $white;
  }
}

@media (max-width: 330px) {
  .btn {
    width: 110px;
    height: 36px;
  }
}

.v-tabs__slider {
  height: 4px !important;
}

//Componentes Externos que requieren css en el App.vue
.pagination {
  margin-left: 10%;

  .page-link {
    color: gray;
    border: none;
  }

  .page-item.active .page-link {
    color: white;
    background-color: $buttonSecondary !important;
    border-color: $buttonSecondary !important;

    &:hover {
      background-color: $buttonSecondaryOver !important;
      border-color: $buttonSecondaryOver !important;
      color: white;
    }
  }
}

.page-link {
  position: relative;
  display: block;
  margin-left: -1px;
  line-height: 1.25;
  background-color: rgb(255, 255, 255);
  padding: 0.5rem 0.75rem;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(222, 226, 230);
  border-image: initial;
}

.multiselect__tags {
  border: none;
  border-bottom: 1px solid #cccccc;
  border-radius: 0px;
}

.multiselect__option
.multiselect__option--highlight
.multiselect__option--selected {
  background: $bgMultiselect !important;
  color: black !important;
}

.multiselect__option--highlight {
  background: $bgMultiselect;
  color: black !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: $bgMultiselect !important;
  color: black !important;
}

.chart {
  svg {
    text {
      font-size: 0.6px !important;
    }
  }
}

.flowpaper_tbseparator:nth-of-type(2) {
  display: none;
}

.flowpaper_bttnPrint {
  display: none;
}

.flowpaper_bttnSinglePage {
  display: none;
}

.flowpaper_bttnTwoPage {
  display: none;
}

.flowpaper_bttnThumbView {
  display: none;
}

.flowpaper_bttnRotate {
  display: none;
}

.flowpaper_bttnFullScreen {
  display: none;
}

body .zt-header-menu {
  width: 290px;
}

// Cuando es iframe, cambiar el color primary
.iframe-mode {
  --v-primary-base: #2694fc !important;
}

// Fix para menús desplegables de Vuetify que se renderizan fuera del componente
body.iframe-mode .v-menu__content .v-list__tile--active .v-list__tile__title,
body.iframe-mode .v-menu__content .v-list__tile--active .primary--text,
body.iframe-mode .v-menu__content .primary--text,
body.iframe-mode .v-menu__content .v-list__tile__title.primary--text {
  color: #2694fc !important;
}

// Fix para el paginador de v-datatable
.iframe-mode .v-datatable .primary--text,
.iframe-mode .v-datatable .v-select.primary--text,
.iframe-mode .v-datatable .v-select.primary--text .v-select__selection,
.iframe-mode .v-datatable .v-input.primary--text .v-icon {
  color: #2694fc !important;
}

// Fix para la línea de subrayado del input en el paginador
.iframe-mode .v-datatable .v-input.primary--text .v-input__slot::after,
.iframe-mode .v-datatable .v-input.primary--text .v-input__slot::before,
.iframe-mode .v-input.primary--text .v-input__slot::after {
  border-color: #2694fc !important;
}

// Fix para background primary en iframe
.iframe-mode .bg-zt-primary-200,
body.iframe-mode .bg-zt-primary-200 {
  background-color: #2694fc !important;
}

// Fix para SweetAlert en iframe mode
body.iframe-mode .buttonSwallConfirmProperties {
  background-color: #2694fc !important;
  border-color: #2694fc !important;
  
  &:hover {
    background-color: #1a7cd6 !important;
    border-color: #1a7cd6 !important;
  }
  
  &:focus {
    outline-color: #1a7cd6 !important;
  }
}

body.iframe-mode .buttonSwallCancelProperties {
  border-color: #2694fc !important;
  color: #2694fc !important;
  
  &:hover {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
  }
  
  &:focus {
    outline-color: #2694fc !important;
  }
}

//Componentes Externos que requieren css en el App.vue
</style>
